import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import microseconds from "microseconds";
import { shuffle } from "lodash";

Vue.use(Vuex);

console.log(process.env.VUE_APP_ENV);

const apiUrl = process.env.VUE_APP_API_URL || "https://4knd6mhi4ngfbi7bdkgrnddpey.appsync-api.ap-southeast-1.amazonaws.com/graphql";
const headers = { "x-api-key": process.env.VUE_APP_API_KEY || "da2-qaddm6lptrckni46dprwnm2l5e" };

export default new Vuex.Store({
  state: {
    isApiCalling: false,
    isLoaded: false,
    isRegistered: true,
    isConfirmed: false,
    readInstructions: false,
    isCompleted: false,
    userName: null,
    emailId: null,
    mobileNumber: 0,
    currentQuestionIndex: 0,
    quiz: [],
    tempQuestions: [],
    userResponses: {},
    elapsedTime: 0,
    timer: null,
    score: 0,
    correctAns: 0,
    hasPlayed: true,
    startTime: 0,
    bookingId: null,
    eventId: null,
    eventName: null,
    user_array: [],
    IdEvent: null,
    quizUrl: null,
    hasError: true,
    instructions: null,
    quizName: null,
    consentText: null,
    promoText: null,
    welcomeText: null,
    facebookLink: null,
    linkedinLink: null,
    twitterLink: null,
    linkedEventUrl: null,
    registrationRequired: null,
    quizStatus: null,
    logo: null,
    textColor: null,
    backgroundColor: null,
    primaryColor: null,
    organisationName: null,
    showDetails: true,

  },
  getters: {
    showDetails: state => state.showDetails,
    organisationName: state => state.organisationName,
    isApiCalling: state => state.isApiCalling,
    textColor: state => state.textColor,
    primaryColor: state => state.primaryColor,
    backgroundColor: state => state.backgroundColor,
    logo: state => state.logo,
    quizStatus: state => state.quizStatus,
    isLoaded: state => state.isLoaded,
    registrationRequired: state => state.registrationRequired,
    quizUrl: state => state.quizUrl,
    IdEvent: state => state.IdEvent,
    user_array: state => state.user_array,
    startTime: state => state.startTime,
    userName: state => state.userName,
    mobileNumber: state => state.mobileNumber,
    emailId: state => state.emailId,
    userResponses: state => state.userResponses,
    quiz: state => state.tempQuestions,
    tempQuestions: state => state.tempQuestions,
    elapsedTime: state => state.elapsedTime,
    currentQuestionIndex: state => state.currentQuestionIndex,
    question: state => state.tempQuestions[state.currentQuestionIndex],
    questionIndex: state => state.currentQuestionIndex,
    totalQuestions: state => state.tempQuestions.length,
    isRegistered: state => state.isRegistered,
    isConfirmed: state => state.isConfirmed,
    readInstructions: state => state.readInstructions,
    isCompleted: state => state.isCompleted,
    formattedElapsedTime: state => {
      const date = new Date(null);
      date.setSeconds(state.elapsedTime / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
    },
    timeFor: state => {
      const date = new Date(null);
      return date.setSeconds(state.elapsedTime);
    },
    score: state => state.score,
    correctAns: state => state.correctAns,
    hasPlayed: state => state.hasPlayed,
    bookingId: state => state.bookingId,
    eventId: state => state.eventId,
    eventName: state => state.eventName,
    hasError: state => state.hasError,
    instructions: state => state.instructions,
    quizName: state => state.quizName,
    consentText: state => state.consentText,
    promoText: state => state.promoText,
    welcomeText: state => state.welcomeText,
    facebookLink: state  => state.facebookLink,
    linkedinLink: state => state.linkedinLink,
    twitterLink: state => state.twitterLink,
    linkedEventUrl: state => state.linkedEventUrl

  },
  mutations: {
    EVENTIDFETCHING(state, payload){
      state.eventId = payload.quizId;
      state.IdEvent = payload.linkedEventId;
      state.quizStatus = payload.quizStatus
      state.logo = payload.logo
      state.registrationRequired = payload.registrationRequired
      state.textColor= payload.textColor
      state.backgroundColor = payload.backgroundColor
      state.primaryColor = payload.primaryColor

      if(payload.registrationRequired === true ){
        state.isRegistered = true
        state.isConfirmed = false
        state.isLoaded = true
      }
      else{
        state.isRegistered = false
        state.isConfirmed = true
        state.isLoaded = true
      }

    },
    SHOWDETAILS(state){
      state.showDetails = false
    },
    USERDETAILSREAD(state){
      state.showDetails = true
    },
    APICALLING(state){
      state.isApiCalling = true
    },

    APICALLINGDONE(state){
      state.isApiCalling = false
    },

    LEADERBOARD(state,payload){
      state.user_array = payload.map((row,index) => {
        row.rank = index+1
        return row
      })
    },

    REGISTER(state) {
      state.isRegistered = true;
    },

    CONFIRMED(state, data) {
      state.isConfirmed = true;
      state.emailId = JSON.parse(data.data.data.validateKonfhubRegistration).email_id;
      state.userName = JSON.parse(data.data.data.validateKonfhubRegistration).name;
      state.mobileNumber = JSON.parse(data.data.data.validateKonfhubRegistration).phone_number;
      state.organisationName = JSON.parse(data.data.data.validateKonfhubRegistration).organisation;
    },

    CONFIRMEDBYEMAIL(state, data) {
      state.isRegistered = true;
      state.emailId = data.emailId
      state.userName = data.userName
      state.mobileNumber = data.mobileNumber
    },

    CONFIRM(state, payload) {
      state.bookingId = payload.bookingId;
    },
    READ_INSTRUCTIONS(state) {
      state.timer = setInterval(() => {
        state.elapsedTime += 1000;
      }, 1000);
      state.startTime = microseconds.now();
      state.readInstructions = true;
    },
    HAS_ERROR(state){
      state.isRegistered = true;
      state.isConfirmed = true;
      state.readInstructions = true;
      state.isCompleted = true;
      state.hasPlayed = true;
      state.hasError = false;
    },
    HAVE_ATTEMPTED(state) {
      state.isRegistered = true;
      state.isConfirmed = true;
      state.readInstructions = true;
      state.isCompleted = true;
      state.hasPlayed = false;
    },

    TEMP_QUIZ_VALUES(state, quiz){

      let array = []
      quiz.data.data.getQuestionsById.message.map((item) =>
        array.push(Object.assign({} , item))

      )

      array.map((row, idx) => {
        let tempOptions = []
        row.options.map((e) => {
          tempOptions.push(e)
        })
        row.options = [...shuffle(row.options)]
      })
      state.tempQuestions = array
    },

    UPDATE_QUIZ(state, quiz) {
      state.quiz = quiz.data.data.getQuestionsById.message;
    },

    NEXT_QUESTION(state) {
      state.currentQuestionIndex = state.currentQuestionIndex + 1;
    },

    FINAL_VALIDATE(state){
      const optionArray = Object.keys(state.userResponses)
      const answer = Object.values(state.userResponses)
      let answerValues  = [], finalAnswers  = [];
      let optionsArray = [];
      let optionsArray2 = [];
      optionArray.map((optionVal, idx) => {
        state.tempQuestions.map((tempVal, idx) => {
          {
            if(parseInt(optionVal) === tempVal.questionId)
            optionsArray.push(tempVal.options)
          }
        })
      })

      optionArray.map((optionVal, idx) => {
        state.quiz.map((tempVal, idx) => {
          {
            if(parseInt(optionVal) === tempVal.questionId)
            optionsArray2.push(tempVal.options)
          }
        })
      })

      optionsArray.map((value, idx) => {
        answerValues.push(value[answer[idx]-1])
      })

      optionsArray2.map((item,idx) => {
       finalAnswers.push(item.indexOf(answerValues[idx])+1)
       })
       Object.keys(state.userResponses).forEach((key,idx) => state.userResponses[key] = finalAnswers[idx] );
    },

    UPDATE_OPTIONS(state, option) {
      state.userResponses[option.id] = option.selected;
      // state.userResponses[state.currentQuestionIndex] = option;
      // this.$store.dispatch('nextQuestion', this.optionSelected)
    },
    DISPLAY_SCORE(state, data) {
      state.score = JSON.parse(data).score
      state.correctAns = JSON.parse(data).correctOptionsCount
      state.isCompleted = true;
    },
    COMPLETE_QUIZ(state){
      state.quizStatus = "completed"
    },
    YET_TO_START_QUIZ(state){
      state.quizStatus = "yetToStart"
    },
    STOP_QUIZ(state) {
      clearInterval(state.timer);
    },
    EVENTURL(state, payload){
      state.quizUrl = payload
    },
    QUIZ_VALUES(state, payload){
      state.instructions = payload.instructions[0]
      state.quizName = payload.quizName
      state.consentText = payload.consentText
      state.promoText = payload.promoText
      state.welcomeText = payload.welcomeText
      if(payload.twitterLink === ""){
        state.twitterLink= "https://twitter.com/KonfHub"
      }else{
        state.twitterLink = payload.twitterLink
      }
      if(payload.linkedinLink === ""){
        state.linkedinLink = "https://www.linkedin.com/company/konfhub-technologies-llp/"
      }else{
        state.linkedinLink = payload.linkedinLink
      }
      if(payload.facebookLink === ""){
        state.facebookLink = "https://www.facebook.com/konfhub"
      }else{
        state.facebookLink = payload.facebookLink
      }
      state.linkedEventUrl = payload.linkedEventUrl
      state.textColor= payload.textColor
      state.backgroundColor = payload.backgroundColor
      state.primaryColor = payload.primaryColor
    },
    QUIZLOGO(state, payload){
      state.logo = payload.logo
      state.linkedEventUrl = payload.linkedEventUrl
      state.textColor= payload.textColor
      state.backgroundColor = payload.backgroundColor
      state.primaryColor = payload.primaryColor
    }
  },
  actions: {
    leaderBoard(context, payload){
     const query1 = {
      query: `query MyQuery {
        settingsByQuizUrl(quizUrl: "${payload.eventId}") {
          items {
            quizId
            logo
            linkedEventUrl
            textColor
            backgroundColor
            primaryColor
          }
        }
      }`
    };
    return axios
    .post(apiUrl, query1, { headers })
    .then(data => {
      if (data.data.data.settingsByQuizUrl.items[0].quizId) {
        context.commit('QUIZLOGO',data.data.data.settingsByQuizUrl.items[0])
        if(data.data.data.settingsByQuizUrl.items[0].quizId === 'c6bcaea1-d347-4fd0-9eb1-d2b9f2f0e14c'){
          context.dispatch('leaderboardData2', {key: data.data.data.settingsByQuizUrl.items[0].quizId})
        }else{
          context.dispatch('leaderboardData', {key: data.data.data.settingsByQuizUrl.items[0].quizId})
        }
      }
    })
    .catch(error => {
      location.replace("/error");
    });
    },
    leaderboardData2(context,payload){
      const query = {
        query: `query MyQuery {
          leaderboardByScore(quizId:"${payload.key}", score: {gt: -1}){
          items {
              name
              score
              timeConsumed
              correctOptionsCount
          }
          }
          }`
      };
      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          context.commit('LEADERBOARD', data.data.data.leaderboardByScore.items)

        })
        .catch(error => {
        });

    },


    leaderboardData(context, payload){
      const query = {
        query: `query MyQuery {
          leaderboardByScore(quizId:"${payload.key}", score: {gt: -1}, limit:25000){
          items {
              name
              score
              timeConsumed
              correctOptionsCount
          }
          }
          }`
      };
      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          context.commit('LEADERBOARD', data.data.data.leaderboardByScore.items)

        })
        .catch(error => {
        });
    },

    getEventId(context,payload){
      var d = new Date();
      const query = {
        query: `query MyQuery {
          statusByQuizUrl(quizUrl: "${payload.eventId}" userTime:${(d.getTime()-d.getMilliseconds())/1000})
        }`
      };
      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          if (JSON.parse(data.data.data.statusByQuizUrl).items[0].quizId) {
            context.commit("EVENTIDFETCHING", JSON.parse(data.data.data.statusByQuizUrl).items[0]);
            context.commit("EVENTURL", payload.eventId)
            context.dispatch('displayQuizDetails', {key: JSON.parse(data.data.data.statusByQuizUrl).items[0].quizId})
          }
        })
        .catch(error => {
          location.replace("/error");
        });
    },
    register(context) {
      context.commit("REGISTER");
    },
    readUserDetails(context){
      context.commit("USERDETAILSREAD")
    },
    confirm(context, payload) {
      context.commit("APICALLING")
      context.commit("CONFIRM", payload);
      const query = {
        query: `query{
          validateKonfhubRegistration(quizId:"${context.getters.eventId}" validateBy:"${payload.bookingId}" eventId: "${context.getters.IdEvent}")
        }`
      };
      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          context.commit("APICALLINGDONE")
          if (JSON.parse(data.data.data.validateKonfhubRegistration).playedQuiz === true) {
            context.commit("HAVE_ATTEMPTED");
          }
          else if(JSON.parse(data.data.data.validateKonfhubRegistration).playedQuiz === false){
            context.commit("SHOWDETAILS")
            context.commit("CONFIRMED", data);
          }
          else {
            context.commit("HAS_ERROR")
          }
        })
        .catch(error => {
          //location.replace("/error-invalid-creditentals");
        });
    },
    confirmbyEmail(context, payload){
      context.commit("APICALLING")
      const query = {
        query: `query{
          validateParticipant(quizId:"${context.getters.eventId}" emailId:"${payload.emailId}" )
        }`
      };

      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          context.commit("APICALLINGDONE")
          if (data.data.data.validateParticipant !== null) {
            context.commit("HAVE_ATTEMPTED");
          }
          else {
            context.commit("CONFIRMEDBYEMAIL", payload);
          }

        })
        .catch(error => {
        });
    },

    readInstructions(context) {
      var d = new Date();
      const query = {
        query: `query MyQuery {
          getQuestionsById(quizId: "${context.getters.eventId}" userTime:${(d.getTime()-d.getMilliseconds())/1000})
        }`
      };
      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          data.data.data.getQuestionsById = JSON.parse(data.data.data.getQuestionsById);
          context.commit("READ_INSTRUCTIONS");
          context.commit("UPDATE_QUIZ", {
            data: data.data
          });
          context.commit("TEMP_QUIZ_VALUES", {
            data: data.data
          });
        })
        .catch(error => {
        });
    },

    submitRespose(context){

    },

    nextQuestion(context, option) {
      context.commit("APICALLING")
      var d = new Date();
      context.commit("UPDATE_OPTIONS", option);
      if (context.getters.currentQuestionIndex + 1 < context.getters.quiz.length) {
        // eslint-disable-next-line no-plusplus
        context.commit("NEXT_QUESTION", option);
      } else {
        context.commit("STOP_QUIZ");
        context.commit("FINAL_VALIDATE")
        let endtime = microseconds.since(context.getters.startTime);
        var value ={ quizId: `${context.getters.eventId}`, name: `${context.getters.userName}`, emailId: `${context.getters.emailId}`, countryCode: "+91", phoneNumber: `${context.getters.mobileNumber}` ,  timeConsumed: `${endtime}`, userTime:`${(d.getTime()-d.getMilliseconds())/1000}`, selectedOptions: `${JSON.stringify(context.getters.userResponses)}` }
        const encryption = (str) => {
          const key = parseInt(
            (
              ((17232332233 / 2312323) * 23232 -
                ((36456234242423 * 73647346343) % 3434)) *
                ((17232332233 / 2312323) * 23232 -
                  ((36456234242423 * 73647346343) % 3434)) -
              29975142603379940
            ).toString()
          );
          var pos = 0;
          let ostr = '';
          while (pos < str.length) {
            ostr = ostr + String.fromCharCode(key ^ str.charCodeAt(pos));
            pos += 1;
          }
          return ostr
        };

      const query = {
        query: `mutation {
          submit(value: "${encryption(JSON.stringify(value))}")
        }
      `
      };
      return axios
        .post(apiUrl, query, { headers })
        .then(data => {
          context.commit("APICALLINGDONE")
          if(JSON.parse(data.data.data.submit).statusCode === 403 && JSON.parse(data.data.data.submit).message === "user already submitted the quiz"){
           context.commit("HAVE_ATTEMPTED")
          } else if(JSON.parse(data.data.data.submit).statusCode === 403 ){
            if(JSON.parse(data.data.data.submit).quizStatus === "completed"){
              context.commit("COMPLETE_QUIZ")
            } else if (JSON.parse(data.data.data.submit).quizStatus.toLowerCase() === "yettostart"){
             context.commit("YET_TO_START_QUIZ")
            }
          }
          else{
            context.commit("DISPLAY_SCORE", JSON.parse(data.data.data.submit));
          }
        })
        .catch(error => {
        });

      }
      return false;
    },

    displayQuizDetails(context,payload){
      const query = {
        query: `query{
          listQuizDetails(quizId:"${payload.key}"){
            items{
              quizName
              instructions
              welcomeText
              consentText
              promoText
              facebookLink
              linkedinLink
              twitterLink
              linkedEventUrl
              textColor
              backgroundColor
              primaryColor
            }
          }
        }`
      };


      return axios
      .post(apiUrl, query, { headers })
      .then(data => {
        context.commit("QUIZ_VALUES", data.data.data.listQuizDetails.items[0]);
      })
      .catch(error => {
      });

    }
  }
});
